<template>
  <!-- Para identificar el SVG se utiliza un name que represente el icono a utilizar   Ejemplo = name==eventDetention  -->
  <svg
    v-if="name == 'eventDetention'"
    width="29px"
    height="29px"
    viewBox="0 0 29 29"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Group" transform="translate(2.934066, 1.000000)" fill="#45A193" fill-rule="nonzero">
      <rect id="Rectangle" x="7.17216117" y="0" width="7.17216117" height="2.38095238"></rect>
      <path
        d="M19.1616239,7.60714286 L20.8590354,5.91666667 C20.3450305,5.30952381 19.7832112,4.73809524 19.1735775,4.23809524 L17.4761661,5.92857143 C15.6233578,4.45238095 13.2924054,3.57142857 10.7582418,3.57142857 C4.81730159,3.57142857 0,8.36904762 0,14.2857143 C0,20.202381 4.80534799,25 10.7582418,25 C16.7111355,25 21.5164835,20.202381 21.5164835,14.2857143 C21.5164835,11.7619048 20.631917,9.44047619 19.1616239,7.60714286 Z M11.953602,15.4761905 L9.56288156,15.4761905 L9.56288156,8.33333333 L11.953602,8.33333333 L11.953602,15.4761905 Z"
        id="Shape"
      ></path>
    </g>
  </svg>
  <svg
    v-else-if="name == 'eventDoorOpen'"
    width="29px"
    height="29px"
    viewBox="0 0 29 29"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>meeting_room_black_24dp</title>
    <path
      d="M16.8980464,6.16666667 L16.8980464,27 L1.95604396,27 L1.95604396,24.2222222 L4.67277167,24.2222222 L4.67277167,2 L16.8980464,2 L16.8980464,3.38888889 L23.6898657,3.38888889 L23.6898657,24.2222222 L26.4065934,24.2222222 L26.4065934,27 L20.973138,27 L20.973138,6.16666667 L16.8980464,6.16666667 Z M11.7362637,13 L11.7362637,16 L14.6703297,16 L14.6703297,13 L11.7362637,13 Z"
      id="Shape"
      fill="#F17B1B"
      fill-rule="nonzero"
    ></path>
  </svg>
  <svg
    v-else-if="name == 'eventSpeed'"
    width="29px"
    height="29px"
    viewBox="0 0 29 29"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>speed_black_24dp</title>
    <path
      d="M24.5117967,10.3946871 L23.0653745,12.5967658 C24.4822803,15.4572577 24.3850887,18.8468422 22.8066648,21.6193369 L6.5079563,21.6193369 C4.43415931,17.9778022 4.96438157,13.3907212 7.81265079,10.3321095 C10.66092,7.27349794 15.1534507,6.46689975 18.8672223,8.34734906 L21.0427353,6.8832643 C16.4845155,3.92466661 10.5195963,4.49913503 6.59438031,8.27475401 C2.66916434,12.050373 1.79844991,18.05102 4.48531715,22.8096497 C4.90290346,23.5417981 5.67276848,23.9948597 6.5079563,23.9999814 L22.7949053,23.9999814 C23.6384981,24.0033525 24.4192704,23.5491534 24.8410635,22.8096497 C27.0502603,18.935979 26.9276126,14.1356895 24.5235562,10.382784 L24.5117967,10.3946871 Z M12.9992168,18.5364267 C13.4403598,18.9834536 14.0389727,19.2346324 14.6631903,19.2346324 C15.2874079,19.2346324 15.8860209,18.9834536 16.3271638,18.5364267 L22.9830578,8.43067095 L12.9992168,15.1678415 C12.5575829,15.6143713 12.3094342,16.220294 12.3094342,16.8521341 C12.3094342,17.4839741 12.5575829,18.0898969 12.9992168,18.5364267 L12.9992168,18.5364267 Z"
      id="Shape"
      fill="#C21F64"
      fill-rule="nonzero"
    ></path>
  </svg>
  <svg
    v-else-if="name == 'eventErrorGps'"
    width="29px"
    height="29px"
    viewBox="0 0 29 29"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>share_location_black_24dp (1)</title>
    <g id="Group" transform="translate(1.956757, 2.000000)" fill="#52D7C0" fill-rule="nonzero">
      <path
        d="M12.9416791,21.5638191 L12.9416791,24 C15.3086286,23.758794 17.4636125,22.7939698 19.2064409,21.3346734 L17.5342677,19.6100503 C16.2271463,20.6472362 14.6609558,21.3467337 12.9416791,21.5638191 Z"
        id="Path"
      ></path>
      <path
        d="M2.35517363,12 C2.35517363,7.11557789 5.92326168,3.06331658 10.539402,2.4361809 L10.539402,0 C4.61614031,0.63919598 0,5.77688442 0,12 C0,18.2231156 4.61614031,23.360804 10.539402,24 L10.539402,21.5638191 C5.92326168,20.9366834 2.35517363,16.8844221 2.35517363,12 Z"
        id="Path"
      ></path>
      <path
        d="M21.1023557,10.7939698 L23.4810811,10.7939698 C23.2455637,8.36984925 22.3034943,6.16281407 20.8786142,4.37788945 L19.1946651,6.10251256 C20.2073897,7.42914573 20.8903901,9.03316583 21.1023557,10.7939698 Z"
        id="Path"
      ></path>
      <path
        d="M19.2064409,2.66532663 C17.4636125,1.20603015 15.2968527,0.24120603 12.9416791,0 L12.9416791,2.4361809 C14.6609558,2.65326633 16.2271463,3.35276382 17.5342677,4.38994975 L19.2064409,2.66532663 Z"
        id="Path"
      ></path>
      <path
        d="M19.1946651,17.9095477 L20.8786142,19.6221106 C22.3034943,17.8371859 23.2455637,15.6301508 23.4810811,13.2060302 L21.1023557,13.2060302 C20.8903901,14.9668342 20.2073897,16.5708543 19.1946651,17.9095477 Z"
        id="Path"
      ></path>
      <path
        d="M16.4508878,10.9145729 C16.4508878,7.91155779 14.2134729,5.96984925 11.7405405,5.96984925 C9.26760823,5.96984925 7.03019328,7.91155779 7.03019328,10.9145729 C7.03019328,12.9165829 8.59638375,15.2924623 11.7405405,18.0301508 C14.8846973,15.2924623 16.4508878,12.9165829 16.4508878,10.9145729 Z M11.7405405,12 C11.0457643,12 10.4805226,11.4211055 10.4805226,10.7095477 C10.4805226,9.99798995 11.0457643,9.41909548 11.7405405,9.41909548 C12.4353168,9.41909548 13.0005584,9.99798995 13.0005584,10.7095477 C13.0005584,11.4211055 12.4353168,12 11.7405405,12 Z"
        id="Shape"
      ></path>
    </g>
  </svg>
  <svg
    v-else-if="name == 'eventElectricalDisconnection'"
    width="29px"
    height="29px"
    viewBox="0 0 29 29"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>power_off_black_24dp</title>
    <path
      d="M21.2188529,16.9089474 L21.2188529,10.2631579 C21.2188529,9.05263158 20.0110991,7.83 18.8272613,7.84210526 L18.8272613,3 L16.4356697,3 L16.4356697,7.84210526 L11.6524865,7.84210526 L11.6524865,3 L9.26089489,3 L9.26089489,6.00210526 L20.6329129,17.5021053 L21.2188529,16.9089474 L21.2188529,16.9089474 Z M19.1142523,19.0515789 L8.30425826,8.08421053 L8.2923003,8.09631579 L4.4537958,4.21052632 L2.93513514,5.72368421 L6.95300901,9.79105263 C6.91713514,9.94842105 6.8693033,10.1057895 6.8693033,10.2631579 L6.8693033,16.8968421 L11.0545886,21.1578947 L11.0545886,24.7894737 L17.0335676,24.7894737 L17.0335676,21.1578947 L17.6075495,20.5768421 L22.9527568,26 L24.4594595,24.4505263 L19.1142523,19.0515789 L19.1142523,19.0515789 Z"
      id="Shape"
      fill="#0096CA"
      fill-rule="nonzero"
    ></path>
  </svg>
  <svg
    v-else-if="name == 'eventMaxSpeed'"
    width="29px"
    height="29px"
    viewBox="0 0 29 29"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>minor_crash_black_24dp</title>
    <path
      d="M21.9722042,10.8870833 C21.733045,10.1741667 21.0633994,9.66666667 20.2741742,9.66666667 L7.12042042,9.66666667 C6.3311952,9.66666667 5.67350751,10.1741667 5.42239039,10.8870833 L2.93513514,18.125 L2.93513514,27.7916667 C2.93513514,28.45625 3.47324324,29 4.13093093,29 L5.32672673,29 C5.98441441,29 6.52252252,28.45625 6.52252252,27.7916667 L6.52252252,26.5833333 L20.8720721,26.5833333 L20.8720721,27.7916667 C20.8720721,28.45625 21.4101802,29 22.0678679,29 L23.2636637,29 C23.9213514,29 24.4594595,28.45625 24.4594595,27.7916667 L24.4594595,18.125 L21.9722042,10.8870833 Z M7.53894895,12.0833333 L19.8436877,12.0833333 L21.0873153,15.7083333 L6.29532132,15.7083333 L7.53894895,12.0833333 Z M6.52252252,21.1458333 C6.52252252,20.1429167 7.32370571,19.3333333 8.31621622,19.3333333 C9.30872673,19.3333333 10.1099099,20.1429167 10.1099099,21.1458333 C10.1099099,22.14875 9.30872673,22.9583333 8.31621622,22.9583333 C7.32370571,22.9583333 6.52252252,22.14875 6.52252252,21.1458333 Z M17.2846847,21.1458333 C17.2846847,20.1429167 18.0858679,19.3333333 19.0783784,19.3333333 C20.0708889,19.3333333 20.8720721,20.1429167 20.8720721,21.1458333 C20.8720721,22.14875 20.0708889,22.9583333 19.0783784,22.9583333 C18.0858679,22.9583333 17.2846847,22.14875 17.2846847,21.1458333 Z M10.6001862,6.04166667 L8.91411411,7.74541667 L5.32672673,4.12041667 L7.0127988,2.41666667 L10.6001862,6.04166667 Z M18.4804805,7.74541667 L16.7944084,6.04166667 L20.3817958,2.41666667 L22.0678679,4.12041667 L18.4804805,7.74541667 Z M14.8930931,6.04166667 L12.5015015,6.04166667 L12.5015015,0 L14.8930931,0 L14.8930931,6.04166667 Z"
      id="Shape"
      fill="#E6BC21"
      fill-rule="nonzero"
    ></path>
  </svg>
  <svg
    v-else-if="name == 'eventInterferenceGps'"
    width="29px"
    height="29px"
    viewBox="0 0 29 29"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>sensors_off_black_24dp</title>
    <path
      d="M9.83583333,13.2433333 C9.72708333,13.6420833 9.66666667,14.065 9.66666667,14.5 C9.66666667,15.8291667 10.2104167,17.0375 11.0804167,17.9195833 L9.36458333,19.6354167 C8.05958333,18.3183333 7.25,16.5058333 7.25,14.5 C7.25,13.37625 7.50375,12.325 7.95083333,11.3704167 L6.17458333,9.59416667 C5.31666667,11.0320833 4.83333333,12.7116667 4.83333333,14.5 C4.83333333,17.1704167 5.92083333,19.5870833 7.67291667,21.3270833 L5.95708333,23.0429167 C3.77,20.8558333 2.41666667,17.835 2.41666667,14.5 C2.41666667,12.035 3.15375,9.75125 4.4225,7.84208333 L1.67958333,5.09916667 L3.38333333,3.39541667 L25.5925,25.6045833 L23.88875,27.3083333 L9.83583333,13.2433333 Z M21.0491667,17.6295833 C21.49625,16.675 21.75,15.62375 21.75,14.5 C21.75,12.4941667 20.9404167,10.6816667 19.6233333,9.37666667 L17.9075,11.0925 C18.7895833,11.9625 19.3333333,13.1708333 19.3333333,14.5 C19.3333333,14.935 19.2729167,15.3579167 19.1641667,15.7566667 L21.0491667,17.6295833 Z M24.1666667,14.5 C24.1666667,16.2883333 23.6833333,17.9679167 22.8254167,19.4058333 L24.5775,21.1579167 C25.84625,19.24875 26.5833333,16.965 26.5833333,14.5 C26.5833333,11.165 25.23,8.14416667 23.0429167,5.95708333 L21.3270833,7.67291667 C23.0791667,9.41291667 24.1666667,11.8295833 24.1666667,14.5 Z"
      id="Shape"
      fill="#6226F7"
      fill-rule="nonzero"
    ></path>
  </svg>
  <svg
    v-else-if="name == 'eventPanic'"
    width="29PX"
    height="29PX"
    viewBox="0 0 29 29"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>radio_button_checked_black_24dp</title>
    <path
      d="M14.5,8.45833333 C11.165,8.45833333 8.45833333,11.165 8.45833333,14.5 C8.45833333,17.835 11.165,20.5416667 14.5,20.5416667 C17.835,20.5416667 20.5416667,17.835 20.5416667,14.5 C20.5416667,11.165 17.835,8.45833333 14.5,8.45833333 Z M14.5,2.41666667 C7.83,2.41666667 2.41666667,7.83 2.41666667,14.5 C2.41666667,21.17 7.83,26.5833333 14.5,26.5833333 C21.17,26.5833333 26.5833333,21.17 26.5833333,14.5 C26.5833333,7.83 21.17,2.41666667 14.5,2.41666667 Z M14.5,24.1666667 C9.15916667,24.1666667 4.83333333,19.8408333 4.83333333,14.5 C4.83333333,9.15916667 9.15916667,4.83333333 14.5,4.83333333 C19.8408333,4.83333333 24.1666667,9.15916667 24.1666667,14.5 C24.1666667,19.8408333 19.8408333,24.1666667 14.5,24.1666667 Z"
      id="Shape"
      fill="#850F00"
      fill-rule="nonzero"
    ></path>
  </svg>
  <svg
    v-else-if="name == 'eventPanic'"
    width="29PX"
    height="29PX"
    viewBox="0 0 29 29"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>radio_button_checked_black_24dp</title>
    <path
      d="M14.5,8.45833333 C11.165,8.45833333 8.45833333,11.165 8.45833333,14.5 C8.45833333,17.835 11.165,20.5416667 14.5,20.5416667 C17.835,20.5416667 20.5416667,17.835 20.5416667,14.5 C20.5416667,11.165 17.835,8.45833333 14.5,8.45833333 Z M14.5,2.41666667 C7.83,2.41666667 2.41666667,7.83 2.41666667,14.5 C2.41666667,21.17 7.83,26.5833333 14.5,26.5833333 C21.17,26.5833333 26.5833333,21.17 26.5833333,14.5 C26.5833333,7.83 21.17,2.41666667 14.5,2.41666667 Z M14.5,24.1666667 C9.15916667,24.1666667 4.83333333,19.8408333 4.83333333,14.5 C4.83333333,9.15916667 9.15916667,4.83333333 14.5,4.83333333 C19.8408333,4.83333333 24.1666667,9.15916667 24.1666667,14.5 C24.1666667,19.8408333 19.8408333,24.1666667 14.5,24.1666667 Z"
      id="Shape"
      fill="#850F00"
      fill-rule="nonzero"
    ></path>
  </svg>

  <svg
    v-else-if="name == 'eventOutOfRoute'"
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    fill="#648C9E"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <title>verified_user_black_24dp</title>
    <path
      d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
    />
  </svg>
</template>

<script>
export default {
  props: ['name'],
};
</script>
